/**
 * An Attribute Type enum.
 * The type values are consistent with the type value set in the API response.
 */
export default {
  SELECT: 'select',
  BOOLEAN: 'boolean',
  RANGE: 'range',
  RANGE_SELECT: 'rangeSelect',
}

export function isAttribute (attribute) {
  return typeof attribute.type !== 'undefined'
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/attributePanel/services/attributeType.js